import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { AppState } from './app.reducer';
import { environment as env } from '../environments/environment';
import { LocalStorageService } from './common/services/local-storage.service';
import { LoginService } from './auth/services/login.service';
import * as authActions from './auth/auth.actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'propertybr-front';

  viewToast: boolean = false;

  messageToast: String = '';

  constructor(
    private store: Store<AppState>,
    private localStorageService: LocalStorageService,
    private loginService: LoginService
  ) {
    this.loadDatadogScript();
    this.logAppVersion();

    this.store.select('viewToast').subscribe(({ view, message }) => {
      this.viewToast = view;
      this.messageToast = message;
    });
  }

  ngOnInit() {
    this.setUserInfo();
  }

  private logAppVersion() {
    console.info('AppVersion:', env.version);
    console.info('Country:', 'br', 'Env:', env.FRONT_ENV);
  }

  private async setUserInfo() {
    const token = this.localStorageService.get('sessionToken');
    if (token) {
      const { result } = await firstValueFrom(this.loginService.getUserInfo(token));
      const { userInfo, groups = [] } = result;
      this.loginService.notifyLoginDatadog(userInfo);
      this.localStorageService.set('brokerSessionInfo', userInfo);
      this.localStorageService.set('userGroups', groups);
      this.store.dispatch(authActions.setBrokerSessionInfo({ brokerSessionInfo: userInfo }));
      this.store.dispatch(authActions.setUserGroups({ userGroups: groups }));
    }
  }

  loadDatadogScript(): void {
    if (env.FRONT_ENV !== 'dev') {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = `
      window.DD_RUM && window.DD_RUM.init({
        clientToken: '${env.DATADOG.clientToken}',
        applicationId: '${env.DATADOG.applicationId}',
        site: 'datadoghq.com',
        service: '${env.DATADOG.service}',
        env: '${env.DATADOG.env}',
        version: '${env.version}',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'allow',
      });
    `;
      document.head.appendChild(script);
    }
  }
}
